// @ts-nocheck
import { DayOfWeekEnum, WorkingHoursType } from '../../../models/WorkingHours';

export const defaultWorkingHours: WorkingHoursType[] = [
  {
    WorkingHoursID: 1,
    CrmRelationID: 1,
    DayOfWeek: DayOfWeekEnum[1],
    StartOfWorkingDay: '',
    StartOfLunch: '',
    EndOfLunch: '',
    EndOfWorkingDay: '',
    IsActive: false,
  },
  {
    WorkingHoursID: 2,
    CrmRelationID: 1,
    DayOfWeek: DayOfWeekEnum[2],
    StartOfWorkingDay: '',
    StartOfLunch: '',
    EndOfLunch: '',
    EndOfWorkingDay: '',
    IsActive: false,
  },
  {
    WorkingHoursID: 3,
    CrmRelationID: 1,
    DayOfWeek: DayOfWeekEnum[3],
    StartOfWorkingDay: '',
    StartOfLunch: '',
    EndOfLunch: '',
    EndOfWorkingDay: '',
    IsActive: false,
  },
  {
    WorkingHoursID: 4,
    CrmRelationID: 1,
    DayOfWeek: DayOfWeekEnum[4],
    StartOfWorkingDay: '',
    StartOfLunch: '',
    EndOfLunch: '',
    EndOfWorkingDay: '',
    IsActive: false,
  },
  {
    WorkingHoursID: 5,
    CrmRelationID: 1,
    DayOfWeek: DayOfWeekEnum[5],
    StartOfWorkingDay: '',
    StartOfLunch: '',
    EndOfLunch: '',
    EndOfWorkingDay: '',
    IsActive: false,
  },
  {
    WorkingHoursID: 6,
    CrmRelationID: 1,
    DayOfWeek: DayOfWeekEnum[6],
    StartOfWorkingDay: '',
    StartOfLunch: '',
    EndOfLunch: '',
    EndOfWorkingDay: '',
    IsActive: false,
  },
  {
    WorkingHoursID: 7,
    CrmRelationID: 1,
    DayOfWeek: DayOfWeekEnum[7],
    StartOfWorkingDay: '',
    StartOfLunch: '',
    EndOfLunch: '',
    EndOfWorkingDay: '',
    IsActive: false,
  },
];

export const defaultTimeZone: string = 'Africa/Abidjan';
